var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.793 6.79301C6.98053 6.60553 7.23484 6.50022 7.5 6.50022C7.76516 6.50022 8.01947 6.60553 8.207 6.79301L12 10.586L15.793 6.79301C15.8852 6.69749 15.9956 6.62131 16.1176 6.5689C16.2396 6.51649 16.3708 6.48891 16.5036 6.48775C16.6364 6.4866 16.7681 6.5119 16.891 6.56218C17.0138 6.61246 17.1255 6.68672 17.2194 6.78061C17.3133 6.8745 17.3875 6.98615 17.4378 7.10905C17.4881 7.23195 17.5134 7.36363 17.5123 7.49641C17.5111 7.62919 17.4835 7.76041 17.4311 7.88241C17.3787 8.00441 17.3025 8.11476 17.207 8.207L13.414 12L17.207 15.793C17.3892 15.9816 17.49 16.2342 17.4877 16.4964C17.4854 16.7586 17.3802 17.0094 17.1948 17.1948C17.0094 17.3802 16.7586 17.4854 16.4964 17.4877C16.2342 17.49 15.9816 17.3892 15.793 17.207L12 13.414L8.207 17.207C8.0184 17.3892 7.7658 17.49 7.5036 17.4877C7.2414 17.4854 6.99059 17.3802 6.80518 17.1948C6.61977 17.0094 6.5146 16.7586 6.51233 16.4964C6.51005 16.2342 6.61084 15.9816 6.793 15.793L10.586 12L6.793 8.207C6.60553 8.01948 6.50021 7.76517 6.50021 7.5C6.50021 7.23484 6.60553 6.98053 6.793 6.79301Z",
    fill: "#6C6C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.206f98af517d06387d393376174a0989.svg";
export { ForwardRef as ReactComponent };